import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SeminarRegisteredManagermentViewer';

const getListSeminarRegisteredReducer = handleActions({
    [Actions.GetListSeminarRegisteredRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListSeminarRegisteredReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListSeminarRegisteredReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListSeminarRegistered]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: true,
    data: {},
    errors: {},
});

const getDetailSeminarRegisteredReducer = handleActions({
    [Actions.GetDetailSeminarRegisteredRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailSeminarRegisteredReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailSeminarRegisteredReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearDetailSeminarRegistered]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: true,
    data: {},
    errors: {},
});

export default combineReducers({
    listSeminarRegistered: getListSeminarRegisteredReducer,
    detailSeminarRegistered: getDetailSeminarRegisteredReducer,
});
